export default "__VITE_ASSET__DbE2xtFY__"